<template>
    <div class="directory-cost-panel">
    <div class="directory-cost-panel__header">
        <h5>{{ $t(labels[index]) }}</h5>
    </div>
    <div class="directory-cost-panel__body">
    <div v-if="!data">
        <div class="directory-cost-empty">
            <span v-html="emptyText || $t('No Data Found')"></span>
        </div>
    </div>
    <div v-else>
        <div v-for="(item,key) in data" :key="key" class="directory-cost-row" :class="{'is-selected' : item._id==dataSelected[index], 'is-highlighted' : item._id==highlighted, 'is-inactive' : item.status==CostCodeStatusEnum.NOT_IN_USE}">
            <button class="directory-cost-row__content" @click="ItemClicked(item._id,index)" type="button" :title="item.costCode + ' ' + item.originalName"
            >
                <span class="directory-cost-row__code">{{item.costCode}}</span>
                <span class="directory-cost-row__name">{{item.originalName}}</span>
            </button>
            <div class="dropend directory-cost-row__menu">
                <button class="directory-cost-row__toggle" data-bs-toggle="dropdown" type="button" :title="$t('Actions')">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul class="dropdown-menu directory-cost-menu">
                    <li @click="clickUpdate(item, index)" role="button" data-bs-toggle="modal" data-bs-target="#UpdateCostCodeModal" >
                        <a class="dropdown-item" ><i class="fa-solid fa-edit"></i> {{ $t('Edit Item') }}</a>
                    </li>
                    <li @click="onRemoveClicked(item._id,item.costCode)" v-if="item.status!=CostCodeStatusEnum.NOT_IN_USE" >
                        <a class="dropdown-item text-danger" ><i class="fa-solid fa-trash-can"></i> {{ $t('Remove Item') }}</a>
                    </li>
                    <li @click="onRestoreClicked(item._id,item.costCode)" v-if="item.status==CostCodeStatusEnum.NOT_IN_USE" >
                        <a class="dropdown-item directory-cost-menu__restore" ><i class="fa-solid fa-rotate-left"></i> {{ $t('Restore Item') }}</a>
                    </li>
                </ul>
            </div>
        </div>
        
    </div>
    </div>
    </div>
</template>

<script>
import {CostCodeStatusEnum} from '@/helpers/utilities.js'
export default {
    name : 'CostCodeColumn',
    props : ['data','clickItem', 'index', 'labels', 'emptyText', 'clickUpdate', 'highlighted', 'dataSelected','UpdateIndexSelected', 'onRemoveClicked', 'onRestoreClicked' ],
    data(){
        return {
            selected : '',
            CostCodeStatusEnum : CostCodeStatusEnum
        }
    },
    methods : {
        ItemClicked(id){
            const getIndex = this.index + 1
            this.UpdateIndexSelected(this.index,id)
            if(getIndex>2){
                return
            }
            this.clickItem(id,getIndex)
        }
    },
}
</script>
<style scoped>
</style>
